export const getQueryParameters = (queryParams?: {
  [key: string]: string | string[] | undefined;
}): string => {
  const queryStringParams = Object.entries(queryParams ?? {}).flatMap(([key, value]) => {
    if (Array.isArray(value)) {
      return value.map((v) => `${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`);
    }
    return `${encodeURIComponent(key)}=${encodeURIComponent(value ?? '')}`;
  });

  return queryStringParams.length > 0 ? `?${queryStringParams.join('&')}` : '';
};
